import Field from "./Field.vue";
import FieldItem from "./FieldItem.vue";
import InputItem from "./InputItem.vue";

export const CField = {
  install: function(Vue) {
    Vue.component("CField", Field);
  },
};
export const CFieldItem = {
  install: function(Vue) {
    Vue.component("CFieldItem", FieldItem);
  },
};
export const CInputItem = {
  install: function(Vue) {
    Vue.component("CInputItem", InputItem);
  },
};

export { Field, FieldItem, InputItem };
